import {
  IExtractorVendorMapping,
  IRemoveExtractorVendorMappingsResponse,
  ISaveExtractorVendorMappingPayload,
  IUpsertExtractorVendorMappingResponse,
} from 'companySettings/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse } from 'core/types';

const LIST_URL = '/quote/algodocs-extractor-vendor-mapping-list';
const EDIT_URL = '/quote/algodocs-extractor-vendor-mapping-edit';

// The request carries NO parameters at all, on purpose:
// - the endpoint applies no limit while `page`/`page_size` are absent, so the whole company-scoped
//   list (tens of rows, ~150 at the outside) arrives in one response, already `updated_at desc`;
// - that order has no id tiebreaker, and MySQL does not order rows tied on the same second stably
//   across separate LIMIT/OFFSET queries, so walking pages could repeat or skip a row;
// - filtering, sorting and the quick search are the client grid's job. `filters[query]` especially
//   must never be sent: a non-string value there is a PHP TypeError, i.e. a 500 on the list.
export const getExtractorVendorMappings = async (
  signal?: AbortSignal
): Promise<GetManyResponse<IExtractorVendorMapping>> => {
  const { data } = await partfinitiClient.get(`${LIST_URL}/list`, signal);

  return mapRecordsFromServer<IExtractorVendorMapping>(data?.data, data?.recordsFiltered);
};

// The only write entry: an `id`-less payload creates, one carrying an `id` edits. Every record
// field rides one bag named after the entity, serializing to
// `algodocs_extractor_vendor_mapping[extractor_id]=…`.
export const saveExtractorVendorMapping = async (
  data: ISaveExtractorVendorMappingPayload
): Promise<IUpsertExtractorVendorMappingResponse> =>
  partfinitiClient.postForm(`${EDIT_URL}/save`, { algodocsExtractorVendorMapping: data });

export const removeExtractorVendorMappings = async (
  ids: number[]
): Promise<IRemoveExtractorVendorMappingsResponse> =>
  partfinitiClient.postForm(`${EDIT_URL}/remove`, { ids });
